export enum AttachmentType {
  DOCUMENT,
  KRK,
  PAYMENT,
  AUTHORIZATION,
  AUTH_PAYMENT,
  REGISTER,
  OTHER
};